import api from './api'

const SUB_URL = '/moas'

export const searchMoAs = async (q: string) => {
  try {
    const response = await api.post(`${SUB_URL}/search`, { q: q });
    return response.data.results
  } catch (error) {
    console.error('Error fetching search results:', error);
  }
};

export const getAllMoas = async () => {
  try {
      const response = await api.get(`${SUB_URL}/all`);
      return response.data.names
    } catch (error) {
      console.error('Error fetching MoAs:', error);
    }
};

export const getMoaGenes = async (moa: string) => {
  try {
      const response = await api.get(`${SUB_URL}/${moa}/genes`);
      return response.data
    } catch (error) {
      console.error('Error fetching genes:', error);
    }
};
